import { Compass, MapPinned } from "lucide-react";
import { useTranslation } from "../../i18n/LanguageContext";

const IMG =
  "https://images.pexels.com/photos/15227825/pexels-photo-15227825.jpeg?auto=compress&cs=tinysrgb&w=1200";

export default function ExperienceIntro() {
  const { t } = useTranslation();
  const i = t.intro;
  return (
    <section
      data-testid="experience-intro-section"
      id="rolunk"
      className="relative py-16 md:py-32 bg-[#ebe2f5] overflow-hidden scroll-mt-24"
    >
      <div aria-hidden className="pointer-events-none absolute inset-x-0 bottom-0 h-16 md:h-28 bg-gradient-to-b from-transparent to-[#2a162f]" />
      <div className="pointer-events-none absolute top-1/2 -right-32 w-[500px] h-[500px] rounded-full bg-[#83588f] opacity-[0.09] blur-[120px]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-white/10">
            <img
              src={IMG}
              alt={i.badgeBot}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#dfd3ee]/70 via-transparent to-transparent" />
          </div>

          <div className="hidden md:flex absolute -bottom-8 -right-6 glass-strong rounded-2xl p-5 w-72 float-slow">
            <div className="flex items-center gap-3.5">
              <img
                src="/logo.png"
                alt={i.badgeBot}
                className="h-12 md:h-14 w-auto object-contain shrink-0 drop-shadow-[0_2px_10px_rgba(0,0,0,0.3)]"
              />
              <div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#0a0a0a]">
                  {i.badgeTop}
                </div>
                <div className="font-brand text-lg uppercase text-[#0a0a0a] mt-0.5">
                  {i.badgeBot}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <p className="text-eyebrow">{i.eyebrow}</p>
          <h2 className="mt-5 font-serif-display text-[34px] leading-[1.1] sm:text-4xl md:text-5xl lg:text-6xl text-[#0a0a0a] sm:leading-[1.05]">
            {i.titleA}{" "}
            <span className="italic gold-text">{i.titleEm}</span>
            {i.titleB}
          </h2>
          <p className="mt-8 text-lg text-[#594f5a] leading-relaxed">
            {i.body}
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6">
            <div className="border-l border-[#0a0a0a]/30 pl-5">
              <Compass size={18} className="text-[#0a0a0a]" />
              <div className="mt-3 font-serif-display text-2xl text-[#0a0a0a]">
                {i.pillar1Top}
              </div>
              <div className="text-sm text-[#8a7f8f] mt-1">{i.pillar1Bot}</div>
            </div>
            <div className="border-l border-[#0a0a0a]/30 pl-5">
              <MapPinned size={18} className="text-[#0a0a0a]" />
              <div className="mt-3 font-serif-display text-2xl text-[#0a0a0a]">
                {i.pillar2Top}
              </div>
              <div className="text-sm text-[#8a7f8f] mt-1">{i.pillar2Bot}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
